import { render, staticRenderFns } from "./FertilizerProgramDescription.vue?vue&type=template&id=475aebe5&"
import script from "./FertilizerProgramDescription.vue?vue&type=script&lang=js&"
export * from "./FertilizerProgramDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports